import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  RuntimeException1r3t0zl97011n as RuntimeException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  BufferOverflow_SUSPEND_getInstance31wn3v83onf3w as BufferOverflow_SUSPEND_getInstance,
  BufferOverflow_DROP_OLDEST_getInstance19p135qqjnhf2 as BufferOverflow_DROP_OLDEST_getInstance,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/BufferOverflow.mjs';
import {
  Channel3r72atmcithql as Channel,
  _ChannelResult___get_isSuccess__impl__odq1z9363u9zgwpgg09 as _ChannelResult___get_isSuccess__impl__odq1z9,
  _ChannelResult___get_isClosed__impl__mg7kuu1xlv81pnrlsg7 as _ChannelResult___get_isClosed__impl__mg7kuu,
  close$default29t9kascifp5w as close$default,
  cancel$default3ekkkwpkem73o as cancel$default,
  ReceiveChannel24wu5e2tj9lbp as ReceiveChannel,
  SendChannel38sllbxw662ws as SendChannel,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new (WebSocketChannelsConfig())();
        this_0.h5a_1 = this_0.k5d();
        this_0.i5a_1 = this_0.k5d();
        tmp.g5a_1 = this_0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var WebSocketChannelsConfigClass;
function WebSocketChannelsConfig() {
  if (WebSocketChannelsConfigClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance();
        this.h5a_1 = Companion_getInstance_0().l5d_1;
        this.i5a_1 = Companion_getInstance_0().l5d_1;
      }
      k5d() {
        return Companion_getInstance_0().l5d_1;
      }
    }
    initMetadataForClass($, 'WebSocketChannelsConfig', WebSocketChannelsConfig);
    WebSocketChannelsConfigClass = $;
  }
  return WebSocketChannelsConfigClass;
}
function from(_this__u8e3s4, config) {
  // Inline function 'kotlin.with' call
  var tmp;
  if (config.m5d_1 === 2147483647) {
    tmp = Channel(2147483647);
  } else if (config.n5d_1.equals(ChannelOverflow_SUSPEND_getInstance())) {
    tmp = Channel(config.m5d_1, BufferOverflow_SUSPEND_getInstance());
  } else if (config.n5d_1.equals(ChannelOverflow_CLOSE_getInstance())) {
    tmp = new (BoundedChannel())(config.m5d_1);
  } else {
    var message = 'Unsupported channel config.';
    throw IllegalStateException().o(toString(message));
  }
  return tmp;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.l5d_1 = new (ChannelConfig())(2147483647, ChannelOverflow_SUSPEND_getInstance());
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var ChannelConfigClass;
function ChannelConfig() {
  if (ChannelConfigClass === VOID) {
    class $ {
      constructor(capacity, onOverflow) {
        Companion_getInstance_0();
        this.m5d_1 = capacity;
        this.n5d_1 = onOverflow;
      }
      o5d() {
        return this.n5d_1.equals(ChannelOverflow_SUSPEND_getInstance()) && !(this.m5d_1 === 2147483647);
      }
    }
    initMetadataForClass($, 'ChannelConfig');
    ChannelConfigClass = $;
  }
  return ChannelConfigClass;
}
var ChannelOverflow_SUSPEND_instance;
var ChannelOverflow_CLOSE_instance;
var ChannelOverflow_entriesInitialized;
function ChannelOverflow_initEntries() {
  if (ChannelOverflow_entriesInitialized)
    return Unit_instance;
  ChannelOverflow_entriesInitialized = true;
  ChannelOverflow_SUSPEND_instance = new (ChannelOverflow())('SUSPEND', 0);
  ChannelOverflow_CLOSE_instance = new (ChannelOverflow())('CLOSE', 1);
}
var ChannelOverflowClass;
function ChannelOverflow() {
  if (ChannelOverflowClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'ChannelOverflow');
    ChannelOverflowClass = $;
  }
  return ChannelOverflowClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      p5d(capacity) {
        var channel = {_v: null};
        var tmp = BufferOverflow_DROP_OLDEST_getInstance();
        // Inline function 'kotlin.also' call
        var this_0 = Channel(capacity, tmp, (it) => {
          var tmp;
          var tmp_0;
          if (channel._v == null) {
            throwUninitializedPropertyAccessException('channel');
          } else {
            tmp_0 = channel._v;
          }
          if (!tmp_0.x1a()) {
            var tmp_1;
            if (channel._v == null) {
              throwUninitializedPropertyAccessException('channel');
            } else {
              tmp_1 = channel._v;
            }
            tmp_1.p1b(ChannelOverflowException().t5d('Channel overflowed'));
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        channel._v = this_0;
        return this_0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function *_generator_send__qhx0g0($this, element, $completion) {
  var tmp = $this.u5d_1.e1b(element, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var BoundedChannelClass;
function BoundedChannel() {
  if (BoundedChannelClass === VOID) {
    class $ {
      constructor(capacity, delegate) {
        delegate = delegate === VOID ? Companion_instance_1.p5d(capacity) : delegate;
        this.u5d_1 = delegate;
      }
      v5d(element) {
        var result = this.u5d_1.f1b(element);
        if (!_ChannelResult___get_isSuccess__impl__odq1z9(result) && !_ChannelResult___get_isClosed__impl__mg7kuu(result)) {
          this.p1b(ChannelOverflowException().t5d('Channel overflowed'));
        }
        return result;
      }
      f1b(element) {
        return this.v5d((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      w5d(element, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_send__qhx0g0.bind(VOID, this, element), $completion);
      }
      e1b(element, $completion) {
        return this.w5d((element == null ? true : !(element == null)) ? element : THROW_CCE(), $completion);
      }
      p1b(cause) {
        return this.u5d_1.p1b(cause);
      }
      x1a() {
        return this.u5d_1.x1a();
      }
      i1b($completion) {
        return this.u5d_1.i1b($completion);
      }
      u1() {
        return this.u5d_1.u1();
      }
      ox(cause) {
        this.u5d_1.ox(cause);
      }
    }
    protoOf($).r1b = close$default;
    protoOf($).t1b = cancel$default;
    initMetadataForClass($, 'BoundedChannel', VOID, VOID, [ReceiveChannel(), SendChannel()], [1, 0]);
    BoundedChannelClass = $;
  }
  return BoundedChannelClass;
}
var ChannelOverflowExceptionClass;
function ChannelOverflowException() {
  if (ChannelOverflowExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static t5d(message) {
        var $this = this.wa(message);
        captureStack($this, $this.s5d_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ChannelOverflowException');
    ChannelOverflowExceptionClass = $;
  }
  return ChannelOverflowExceptionClass;
}
function ChannelOverflow_SUSPEND_getInstance() {
  ChannelOverflow_initEntries();
  return ChannelOverflow_SUSPEND_instance;
}
function ChannelOverflow_CLOSE_getInstance() {
  ChannelOverflow_initEntries();
  return ChannelOverflow_CLOSE_instance;
}
//region block: init
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  ChannelOverflow_SUSPEND_getInstance as ChannelOverflow_SUSPEND_getInstance2mhr6ng5la4d,
  Companion_getInstance as Companion_getInstance1onda8f6dyvl,
  ChannelConfig as ChannelConfigftdbykui5s0q,
  WebSocketChannelsConfig as WebSocketChannelsConfig1qogztyrywmj9,
  from as from3gpkuvfyl3bft,
};
//endregion

//# sourceMappingURL=WebSocketChannelsConfig.mjs.map
